<template>
  <hdraces-tickets-list :data-func="getTickets" :show-user="true" />
</template>
<script>
  import hdracesService from '../../../services/hdraces.service'

  import hdracesTicketsList from '../../common/hdraces-tickets-list.vue'

  export default {
    name: 'client-hdraces-bets',
    components: { hdracesTicketsList },
    methods: {
      async getTickets(filter) {
        return await hdracesService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/bets/hdraces-bets.vue